import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useDivisi() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/divisi/")
    .then((res: SuccessFetch<{
      payload: {
        divisi_id: number
        divisi_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.divisi_name, value: item.divisi_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)
    
    api.get("/divisi/")
    .then((res: SuccessFetch<{
      payload: {
        divisi_id: number
        divisi_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.divisi_name, value: item.divisi_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}